__turbopack_context__.v({
  "account": "PortalHero-module__4PtRjG__account",
  "avatar": "PortalHero-module__4PtRjG__avatar",
  "brand": "PortalHero-module__4PtRjG__brand",
  "compactHeader": "PortalHero-module__4PtRjG__compactHeader",
  "content": "PortalHero-module__4PtRjG__content",
  "controls": "PortalHero-module__4PtRjG__controls",
  "copy": "PortalHero-module__4PtRjG__copy",
  "cta": "PortalHero-module__4PtRjG__cta",
  "defaultAvatar": "PortalHero-module__4PtRjG__defaultAvatar",
  "defaultBrand": "PortalHero-module__4PtRjG__defaultBrand",
  "description": "PortalHero-module__4PtRjG__description",
  "header": "PortalHero-module__4PtRjG__header",
  "hero": "PortalHero-module__4PtRjG__hero",
  "intro": "PortalHero-module__4PtRjG__intro",
  "layout": "PortalHero-module__4PtRjG__layout",
  "location": "PortalHero-module__4PtRjG__location",
  "photo": "PortalHero-module__4PtRjG__photo",
  "reviews": "PortalHero-module__4PtRjG__reviews",
  "tabbedHeader": "PortalHero-module__4PtRjG__tabbedHeader",
  "topbar": "PortalHero-module__4PtRjG__topbar",
  "withNavigation": "PortalHero-module__4PtRjG__withNavigation",
  "withoutPhoto": "PortalHero-module__4PtRjG__withoutPhoto",
});
